import { useContext, useEffect, useState, useMemo } from 'react'
import "./style.scss"
import Input from '../../Input';
import { AuthContext } from '../../../context/auth';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { addTemplateApi, updateTemplateApi, getTemplatesCategoriesApi, updateTemplateCategoryApi, addTemplateCategoryApi } from '../../../api';
import 'quill-paste-smart';
import { proteinsList } from '../../../utils/proteinName';
import Dropdown from '../../Dropdown';

const Index = ({ setOpenTemplateModal, selectedTemplate, setSelectedTemplate, fetchTemplates, setDeleteTemplateModal, type = null }) => {
  const { setNotification, setIsLoading, isLoading } = useContext(AuthContext)
  const [name, setName] = useState('')
  const [template, setTemplate] = useState('')
  const [templateCategory, setTemplateCategory] = useState('')
  const [categories, setCategories] = useState([])


  useEffect(() => {
    if (selectedTemplate) {
      setName(selectedTemplate.name)
      setTemplate(selectedTemplate.template)
      setTemplateCategory(selectedTemplate.category)
    }
  }, [selectedTemplate])


  const modules = useMemo(() => ({
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'blockquote'],
        [{ list: 'bullet' }],
        ['link'],
        [{ script: 'sub' }, { script: 'super' }],
      ],
    },
    keyboard: {
      bindings: {
        handleEnter: {
          key: [13, 'meta+enter'],
          handler: function (range) {
            const [line] = this.quill.getLine(range.index);
            const lineText = line.domNode.textContent.trim();
            if (lineText === '') return false;
            return true;
          },
        },
      },
    },
  }), []);


  const editTemplate = () => {
    setIsLoading(true)
    updateTemplateApi(selectedTemplate.id, {
      name,
      template,
      category_id: templateCategory?.id
    }).then(() => {
      fetchTemplates()
      setOpenTemplateModal(false)
      setSelectedTemplate(null)
      setNotification({
        message: "Template Updated Successfully.",
        type: "update"
      })
      setIsLoading(false)
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: err || "Something went wrong.",
        type: "red"
      })
    })
  }

    const editTemplateCategory = () => {
    setIsLoading(true)
    updateTemplateApi(selectedTemplate.id, {
      name
    }).then(() => {
      fetchTemplates()
      setOpenTemplateModal(false)
      setSelectedTemplate(null)
      setNotification({
        message: "Template Category Updated Successfully.",
        type: "update"
      })
      setIsLoading(false)
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: err || "Something went wrong.",
        type: "red"
      })
    })
  }

  const addTemplate = () => {
    setIsLoading(true)
    const data = {
      name,
      template,
      category_id: templateCategory?.id
    }
    addTemplateApi(data).then(() => {
      fetchTemplates()
      setOpenTemplateModal(false)
      setSelectedTemplate(null)
      setNotification({
        message: "Template Added Successfully.",
        type: "update"
      })
      setIsLoading(false)
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: err || "Something went wrong.",
        type: "red"
      })
    })
  }

  const addTemplateCategory = () => {
    setIsLoading(true)
    const data = {
      name
    }
    addTemplateCategoryApi(data).then(() => {
      fetchTemplates()
      setOpenTemplateModal(false)
      setSelectedTemplate(null)
      setNotification({
        message: "Template Category Added Successfully.",
        type: "update"
      })
      setIsLoading(false)
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: err || "Something went wrong.",
        type: "red"
      })
    })
  }

  const removeEmptyParagraphs = (html) => {
  return html
    .replace(/^(<p><br><\/p>\s*)+/g, '')
    .replace(/(\s*<p><br><\/p>)+$/g, '');
  };

  useEffect(() =>{
    getTemplatesCategoriesApi().then(res => {
      setCategories(res?.data?.templatesCategories)
    })
  }, [])


  return (
    <div className="small-modal-wrapper">
      <div className="template-modal-content">
        <span className='close' onClick={() => {
          setOpenTemplateModal(false)
          setSelectedTemplate(null)
        }}><i className="fas fa-times"></i></span>
        {selectedTemplate && <span className='delete' onClick={() => {
          setDeleteTemplateModal(true)
        }}>
        <i className="fal fa-trash-alt"></i></span>}
        <h2>{selectedTemplate ? `Edit Template ${type === 'category' ? 'Category' : ''}` : `Add New Template ${type === 'category' ? 'Category' : ''}`}</h2>
        <div className="form-container">
          {!type &&
          <div className='row'>
            <div className="input-container">
              <label htmlFor="category">Template Category<span>*</span></label>
              <Dropdown options={categories} searchable label={'Select Template Category'} value={templateCategory} onChange={(e) => setTemplateCategory(e)} optionType='role' placeholder='Select Template Category' />
            </div>
          </div>
          }
          <div className='row'>
            <div className="input-container">
              <label htmlFor="name">Template {type === 'category' ? 'Category' : ''} Name<span>*</span></label>
              <Input type='text' placeholder='Template Name' value={name} onChange={e => setName(e.target.value)} />
            </div>
          </div>
          {!type &&
          <div>
            <div className="editor-container">
              <div className='quill editor'>
                <ReactQuill
                  theme="snow"
                  modules={modules}
                  placeholder='Type Here...'
                  preserveWhitespace
                  onChange={(e) => {
                    setTemplate(removeEmptyParagraphs(e.replaceAll('&nbsp;', ' ')))
                  }}
                  value={template}
                />
              </div>
            </div>
          </div>
          }
        </div>
        <div className='row'>
          <button className='btn transparent'
            onClick={() => setOpenTemplateModal(false)
            }>Discard
          </button>
          <button className='btn add-btn'
            disabled={!name || isLoading || (!type && !template)}
            onClick={() => {
              if (selectedTemplate) {
                if (type === 'category') {
                  editTemplateCategory()
                } else {
                  editTemplate()
                }
              } else {
                if (type === 'category') {
                  addTemplateCategory()
                } else {
                  addTemplate()
                }
              }
            }}>{selectedTemplate ? `Save Template ${type === 'category' ? 'Category' : ''}` : `Add New Template ${type === 'category' ? 'Category' : ''}`}</button>
        </div>
      </div>
    </div>
  )
}

export default Index